import { configureStore } from "@reduxjs/toolkit";

import adminSlice from "./slices/adminSlice";
import blogSlice from "./slices/blogSlice";
import settingSlice from "./slices/settingSlice";
import landingSlice from "./slices/landingSlice";
import metricSlice from "./slices/metricSlice";

const store = configureStore({
  reducer: {
    admin: adminSlice,
    blog: blogSlice,
    setting: settingSlice,
    landing: landingSlice,
    metrics: metricSlice,
  },
});

export default store;
